
import mitt, { Emitter } from 'mitt'


type Event = Record<string, unknown>


const emitter: Emitter<Event> = mitt();

export default emitter;

